import React from 'react';
import { Flex } from 'antd';
import { useFormik } from 'formik';

import {
    validationSchema,
    getFormFields,
    getInitialValues,
} from '../utils/fields';
import {
    AutoBroadcast,
    autoBroadcastType,
    AutoBroadcastValues,
} from '../service/autoBroadcast.interface';
import { Save } from '../../../../shops/widgets/Save';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';
import { useAppSelector } from '../../../../../store';
import { selectAutoBroadcastByType } from '../store/autoBroadcastsSlice';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { useCreateAutoBroadcastSettingsMutation } from '../service/autoBroadcasts.api';

export const AutoBroadcastDropCartContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const [createBroadcast, { isLoading, isSuccess, isError, error, data }] =
        useCreateAutoBroadcastSettingsMutation();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data);

    const dropCartSettings = useAppSelector(state =>
        selectAutoBroadcastByType(
            state,
            autoBroadcastType.no_cart as AutoBroadcast
        )
    );
    const formFields = getFormFields(autoBroadcastType.no_cart);
    const initialValues =
        dropCartSettings ?? getInitialValues(autoBroadcastType.no_cart);

    const onSave = async (values: AutoBroadcastValues): Promise<void> => {
        const payload = {
            ...values,
        };

        if (values.image === null) {
            delete payload.image;
        }

        await createBroadcast({
            shop_id: current.id,
            payload: payload,
        });
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: onSave,
    });

    return (
        <>
            <Flex vertical gap={16}>
                {formFields.map(({ component: Component, ...field }) => (
                    <Component
                        key={field.fieldName}
                        formik={formik}
                        {...field}
                    />
                ))}
            </Flex>

            <Save
                backRoute={'/app/crm/auto-broadcasts'}
                loading={isLoading}
                onSave={() => formik.handleSubmit()}
                disabled={!formik.isValid || formik.isSubmitting}
            />
        </>
    );
};
